var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAverageWages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_6328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 1.875V13.125H13.125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 9.375C4.375 9.70652 4.5067 10.0245 4.74112 10.2589C4.97554 10.4933 5.29348 10.625 5.625 10.625C5.95652 10.625 6.27446 10.4933 6.50888 10.2589C6.7433 10.0245 6.875 9.70652 6.875 9.375C6.875 9.04348 6.7433 8.72554 6.50888 8.49112C6.27446 8.2567 5.95652 8.125 5.625 8.125C5.29348 8.125 4.97554 8.2567 4.74112 8.49112C4.5067 8.72554 4.375 9.04348 4.375 9.375Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 3.125C6.875 3.45652 7.0067 3.77446 7.24112 4.00888C7.47554 4.2433 7.79348 4.375 8.125 4.375C8.45652 4.375 8.77446 4.2433 9.00888 4.00888C9.2433 3.77446 9.375 3.45652 9.375 3.125C9.375 2.79348 9.2433 2.47554 9.00888 2.24112C8.77446 2.0067 8.45652 1.875 8.125 1.875C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C10 7.83152 10.1317 8.14946 10.3661 8.38388C10.6005 8.6183 10.9185 8.75 11.25 8.75C11.5815 8.75 11.8995 8.6183 12.1339 8.38388C12.3683 8.14946 12.5 7.83152 12.5 7.5C12.5 7.16848 12.3683 6.85054 12.1339 6.61612C11.8995 6.3817 11.5815 6.25 11.25 6.25C10.9185 6.25 10.6005 6.3817 10.3661 6.61612C10.1317 6.85054 10 7.16848 10 7.5Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 1.875L9.375 2.8125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82062 4.15625L10.5525 6.46563",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.8125L6.875 9.0625",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_6328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageWages);
export default __webpack_public_path__ + "static/media/averageWages.8a012fe168cc2046407238adefd9935d.svg";
export { ForwardRef as ReactComponent };